/* eslint-disable radix */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
import TripsIcon from "../../../Common/Svgs/TripsIcon";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import {
  deleteFarmerActivity,
  getOverallSummary,
  getStopSummary,
  getTripDetailsKPI,
} from "../../../Redux/APIs/tripsAPI";
import { updateTrips } from "../../../Redux/Slices/trips.slice";

const DeleteFarmerActivityModal = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const { currentStop, deleteFarmerActivityModal } = useSelector(
    (state) => state.trips,
  );

  const onConfirm = async () => {
    await dispatch(
      deleteFarmerActivity({
        tripId: currentStop.tripId,
        stopId: currentStop.stopId,
        farmerId: deleteFarmerActivityModal?.data?.farmerId,
      }),
    );

    await dispatch(
      getStopSummary({
        stopId: currentStop.stopId,
        tripId: currentStop.tripId,
      }),
    );

    await dispatch(getOverallSummary({ tripId: currentStop.tripId }));
    await dispatch(getTripDetailsKPI({ tripId: currentStop.tripId }));

    dispatch(
      updateTrips({
        key: "toastMessage",
        value: {
          visible: true,
          type: "farmerActivityDeleted",
          id: deleteFarmerActivityModal?.data?.farmerName,
        },
      }),
    );

    onCancel();
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <div className="relative">
            <CustomRoundedImage
              size="w-12 h-12"
              image={<TripsIcon className="text-primary" />}
            />
          </div>

          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            Delete farmer activity
          </p>

          <p className="mt-2 text-xs font-normal text-black font-aileron">
            Are you sure you want to delete this activity from the trip?
          </p>

          <p className="mt-2 text-xs font-normal text-black font-aileron">
            This action cannot be undone.
          </p>
        </div>

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          <Button colors="alert" size="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default DeleteFarmerActivityModal;
